import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'react-bootstrap/lib/Checkbox';

export default class CheckboxControl extends React.Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    checkboxValue: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string,
    dataValue: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inline: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    validateChange: PropTypes.func
  };

  constructor(props){
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.state = { checked: props.dataValue === undefined || props.dataValue === 'false' ? false : props.dataValue }
  }

  componentWillReceiveProps(newProps){
    if(newProps.valueOverride && newProps.dataValue !== this.state.checked){
      this.onChange(newProps.dataValue, true)
    }
  }

  onChange(checked, skipValueChange){
    if (checked !== this.state.checked) {
      this.setState({ checked }, () => {
        let value;
        if (this.props.checkboxValue) {
          value = checked ? this.props.checkboxValue : undefined;
        } else {
          value = checked;
        }
        // order of calling onValueChange and onChange matters
        // when checkboxControl(MaterialCheckbox) is added inside Form
        if (typeof this.props.onValueChange === 'function' && !skipValueChange) {
          this.props.onValueChange({ [this.props.name]: value });
        }
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(value, skipValueChange);
        }
      });
    }
  }

  onCheckChange(event) {
    if (typeof this.props.validateChange === 'function') {
      const performChange = this.props.validateChange(event.currentTarget.checked);

      if (!performChange) {
        event.preventDefault();
        event.stopPropagation();
        event.currentTarget.checked = false;

        return;
      }
    }

    this.onChange(event.currentTarget.checked);
  }

  render() {
    return (
      <Checkbox
        {...this.props}
        aria-describedby={this.props.id}
        aria-label={this.props.ariaLabel || ''}
        checked={this.state.checked}
        className={this.props.className}
        disabled={this.props.disabled}
        inline={this.props.inline}
        name={this.props.name}
        onChange={this.onCheckChange}
        value={this.props.checkboxValue || 'true'}
      >
        {this.props.children || this.props.label}
        {this.props.checkboxValue ? null : <input type="hidden" name={this.props.name} value="false" disabled={this.state.checked} />}
      </Checkbox>
    );
  }
}
